import Affix from "./src/index.vue";

Affix.install = function (Vue, options) {
  Vue.component(Affix.name, Affix);
};

export default Affix;
